import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta:{title:'友道科技官网'},
    component: Home,
  },
  {
    path: '/contact',
    name: 'Contact',
    meta:{title:'联系我们 - 友道科技'},
    component: () => import('@/views/contact'),
  },
  {
    path: '/cases',
    name: 'Cases',
    meta:{title:'设计案例 - 友道科技'},
    component: () => import('@/views/cases'),
  },
  {
    path: '/casesdetail',
    name: 'Casesdetail',
    meta:{title:'设计案例 - 友道科技'},
    component: () => import('@/views/cases/detail'),
  },
  {
    path: '/join',
    name: 'Join',
    meta:{title:'加入我们 - 友道科技'},
    component: () => import('@/views/join'),
  },
  {
    path: '/news',
    name: 'News',
    meta:{title:'新闻中心 - 友道科技'},
    component: () => import('@/views/news'),
  },
  {
    path: '/newsdetail',
    name: 'Newsdetail',
    meta:{title:'新闻中心 - 友道科技'},
    component: () => import('@/views/news/detail'),
  },
  {
    path: '/reason',
    name: 'Reason',
    meta:{title:'选择友道的理由 - 友道科技'},
    component: () => import('@/views/reason'),
  },
  {
    path: '/about',
    name: 'About',
    meta:{title:'关于友道 - 友道科技'},
    component: () => import('@/views/about'),
  },
  {
    path: '/about/honor',
    name: 'Honor',
    meta:{title:'资质证书 - 友道科技'},
    component: () => import('@/views/about/honor'),
  },
  {
    path: '/contact/message',
    name: 'Message',
    meta:{title:'在线留言 - 友道科技'},
    component: () => import('@/views/contact/message'),
  },
  {
    path: '/pay',
    name: 'Pay',
    meta:{title:'支付方式 - 友道科技'},
    component: () => import('@/views/website/pay'),
  },
  {
    path: '/startInfo',
    name: 'StartInfo',
    meta:{title:'建站资料 - 友道科技'},
    component: () => import('@/views/website/startInfo'),
  },
  {
    path: '/icpPrepare',
    name: 'IcpPrepare',
    meta:{title:'网站备案 - 友道科技'},
    component: () => import('@/views/website/icpPrepare'),
  },
  {
    path: '/hostInfo',
    name: 'HostInfo',
    meta:{title:'网站空间 - 友道科技'},
    component: () => import('@/views/website/hostInfo'),
  },
  // {
  //   path: '/about/culture',
  //   name: 'culture',
  //   meta:{title:'企业文化 - 友道科技'},
  //   component: () => import('@/views/about/culture'),
  // },
  // {
  //   path: '/about/honor',
  //   name: 'honor',
  //   meta:{title:'总经理致词 - 友道科技'},
  //   component: () => import('@/views/about/honor'),
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(){
    //x代表横坐标，y代表纵坐标
    return {x:0,y:0};
  }
})

router.beforeEach((to,from,next)=>{
  // if (to.meta.title) {
  //   document.title=to.meta.title
  // }
  next()
})

router.afterEach((to, from) => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }
})

export default router
